import Icon from '@ant-design/icons/lib/components/Icon';
import * as React from 'react';
const ICorporateBusiness = (props: any) => {
    return (
        <Icon
            component={() => {
                return (
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path fill={props.color ?? '#37474F'} d="M2 20.5V3H11.8601V7H22V20.5H2ZM3.55665 19H10.3035V16.5H3.55665V19ZM3.55665 15H10.3035V12.5H3.55665V15ZM3.55665 11H10.3035V8.5H3.55665V11ZM3.55665 7H10.3035V4.5H3.55665V7ZM11.8601 19H20.4434V8.5H11.8601V19ZM14.1358 12.5V11H17.9681V12.5H14.1358ZM14.1358 16.5V15H17.9681V16.5H14.1358Z" />
                    </svg>
                );
            }}
            {...props}
        />
    );
};

export default ICorporateBusiness;
